import request from './http';


export const getSearch = async function (keyWords) {
  return await request.get(`/qynlw/articles/findallfront?title[like]=*${keyWords}*&sort=addtime,DESC`);
}
/**
 * webconfigs
 * @returns 首页数据
 */
export const getFindAll = async function () {
  return await request.get("/qynlw/webconfigs/findall");
}
/**
 * plates
 * @returns 首页数据
 */
export const getFindPage = async function () {
  return await request.get("/qynlw/categorys/findall?page=1&limit=300");
}
/**
 * getPicNews
 * @returns 
 */
export const getPicNews = function () {
  return request.get("/qynlw/articles/findallfront?page=1&limit=10&picnews=1&sort=addtime,DESC");
}
/**
 * getPlatePicNews
 * @returns 
 */
export const getPlatePicNews = function (plateId,childId) {
  if(childId)
  {
    return request.get("/qynlw/articles/findallfront?page=1&limit=10&plateid="+plateId+"&platechildid="+childId+"&picnews=1&sort=addtime,DESC");
  }
  return request.get("/qynlw/articles/findallfront?page=1&limit=10&plateid="+plateId+"&picnews=1&sort=addtime,DESC");
}
/**
 * NewsTop
 * @returns 
 */
 export const getTopNews = function () {
  return request.get("/qynlw/articles/findallfront?page=1&limit=5&topnews=1&sort=addtime,DESC");
}
/**
 * NewsHot
 * @returns 
 */
export const getArticles = function (plateid) {
  return request.get(`/qynlw/articles/findallfront?plateid=${plateid}&sort=top,DESC;addtime,DESC&limit=10`);
}
/**
 * InfoNews
 * @param {*} plateid 
 * @returns 
 */
export const getFindcategory = function (plateid) {
  return request.get(`/qynlw/articles/findcategory?plateid=${plateid}&sort=top,DESC;addtime,DESC&limit=4`);
}
/**
 * getCertTypes
 * @returns 
 */
export const getCertTypes = function () {
  return request.get(`/qynlw/certTypes/findallfront?sort=createdAt&limit=20`);
}
/**
 * 广告
 * @returns 
 */
export const getAd = function () {
  return request.get("/qynlw/promotions/findallfront");
}
/**
 * 某个分类的广告
 * @returns 
 */
 export const getAdsOfType = function (typename) {
  return request.get("/qynlw/promotions/findallfront?position="+typename);
}
/**
 * 出版书籍
 * @returns 
 */
 export const getBooks = function () {
  return request.get("/qynlw/books/findallfront?sort=createdAt,DESC&limit=10");
}
/**
 * 出版书籍
 * @returns 
 */
 export const getBooksOfType = function (typeId) {
  return request.get("/qynlw/books/findallfront?platechildid="+typeId+"&sort=createdAt,DESC&limit=10");
}
/**
 * 单个出版书籍
 * @returns 
 */
 export const getBookInfo = function (uuid) {
  return request.get(`/qynlw/books/findone/${uuid}`);
}
/**
 * 单个出版书籍
 * @returns 
 */
 export const getBookArt = function (uuid) {
  return request.get(`/qynlw/bookChapterContents/findone/${uuid}`);
}
/**
 * 书籍中最新论文
 * @returns 
 */
 export const getLastBookArt = function (uuid) {
  return request.get(`/qynlw/bookChapterContents/findallfront?bookid=${uuid}&sort=createdAt,DESC&limit=1`);
}
/**
 * 友情链接
 * @returns 
 */
export const getLiveBlogroll = function () {
  return request.get("/qynlw/links/findallfront?sort=createdAt,DESC&limit=100");
}

/**
 * 文章列表
 * @param {*} plateId 
 * @param {*} intCurrent 
 * @returns 
 */
export const getNewsViews = function (plateId, intCurrent, number = 100,childId=null) {
  if(childId)
  {
    return request.get(`/qynlw/articles/findallfront?plateid=${plateId}&platechildid=${childId}&page=${intCurrent}&limit=${number}&sort=top,DESC;addtime,DESC`);
  }else{
    return request.get(`/qynlw/articles/findallfront?plateid=${plateId}&page=${intCurrent}&limit=${number}&sort=top,DESC;addtime,DESC`);
  }
 
}

/**
 * 文章
 * @param {*} articleId 
 * @returns 
 */
export const getNewsInfo = function (articleId) {
  return request.get(`/qynlw/articles/findone/${articleId}`);
}

/**
 * 文章列表
 * @param {*} plateId 
 * @param {*} childPlateId 
 * @param {*} intCurrent 
 * @returns 
 */
 export const getChildNewsViews = function (plateId, childPlateId,intCurrent, number = 100) {
  return request.get(`/qynlw/articles/findallfront?plateid=${plateId}&platechildid=${childPlateId}&page=${intCurrent}&limit=${number}&sort=top,DESC;addtime,DESC`);
}

/**
 * articleId==="000000"时的处理
 * @param {*} plateId 
 * @returns 
 */
export const getNewsViewsZero = function (plateId,childPlateId=null) {
  if(childPlateId)
  {
    return request.get(`/qynlw/articles/findallfront?plateid=${plateId}&platechildid=${childPlateId}&sort=createdAt,DESC`);
  }else{
    return request.get(`/qynlw/articles/findallfront?plateid=${plateId}&sort=createdAt,DESC`);
  }
  
}

/**
 * 获取单个栏目信息
 * @param {*} uuid 
 * @returns 
 */
 export const getCategoryInfo = function (uuid) {
  return request.get(`/qynlw/categorys/findone/${uuid}`);
}

/**
 * 获取自身用户数据
 * @returns 
 */
 export const getme = function () {
  return request.get(`/qynlw/users/getme?loginmethod=front`);
}


/**
 * 用户注册
 * @returns 
 */
 export const regUser = function (user) {
  return request.post(`/qynlw/users/register`,user);
}

/**
 * 用户登陆
 * @returns 
 */
 export const loginUser = function (user) {
  return request.post(`/qynlw/users/login`,user);
}
/**
 * 用户退出
 * @returns 
 */
 export const logoutUser = function () {
  return request.post(`/qynlw/users/logout`);
}
/**
 * 获取企业会员
 * @returns
 */
export const getQYMembers = function () {
  return request.get(`/qynlw/companyMembers/findallfront`);
}
/**
 * 获取领导班子
 * @returns
 */
 export const getLeaders = function () {
  return request.get(`/qynlw/leaderJobs/findallfront?limit=300&sort=order,ASC`);
}
/**
 * 获取个人会员
 * @returns
 */
 export const getGRMembers = function (keyword=null, type='0') {
  let opt="";
  if(keyword)
  {
    opt="?name="+keyword
  }
  if(type=='1')
  {
   if(opt) opt+="&type="+type
   else opt+="?type="+type
  }else{
    if(opt) opt+="&type[ne]=1"
    else opt+="?type[ne]=1"
  }
  return request.get(`/qynlw/personalMembers/findallfront${opt}`);
}